// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1BtvZ","ranges":"BmiRanges_ranges__1slar"};